import * as React from 'react';

interface ComponentProps {
  currency?: string | null;
  showCurrencyCode?: boolean;
  value?: number | string;
}

const FormattedCurrency = ({ showCurrencyCode = false, value, currency }: ComponentProps) => {
  const currencyCode = currency ? currency.toUpperCase() : 'USD';

  const formatOptions = { style: 'currency', currency: currencyCode };

  const amount = typeof value === 'string' ? Number(value) : value;

  return (
    <>
      {new Intl.NumberFormat('en-US', formatOptions).format(amount ?? 0)}
      {showCurrencyCode && ` ${currencyCode}`}
    </>
  );
};

export default FormattedCurrency;
